/**
 * `/klienci` — the client roster.
 *
 * It was the app's home at `/` until 23 September 2026, when the owner moved the landing page to
 * the dashboard; its address now matches the client detail and the archive under it.
 *
 * No `validateSearch`, as at `/`: the roster keeps its search, tab and sort in its own state, and a
 * link from another screen writes the list context through `rosterContextSearch`, which serialises
 * nothing for the default. The superseded 30 July spike (`pages/clients`) stays unrouted, by the
 * owner's standing rule that superseded code is left in place rather than deleted.
 */

import { createFileRoute } from '@tanstack/react-router';

import { preloadBookingPolicy } from '~/features/credit-ledger';
import { RosterScreen } from '~/pages/client-roster';
import { queryClient } from '~/shared/lib/queryClient';

export const Route = createFileRoute('/_shell/klienci/')({
  // Whether credits run, before the first frame: the roster's „Rozliczenie" column stands on it.
  loader: () => preloadBookingPolicy(queryClient),
  component: RosterScreen,
});
